import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = { class: "mb-6 bg-white border border-gray-200 rounded-xl p-4 shadow-sm flex flex-col sm:flex-row gap-3" }
const _hoisted_4 = { class: "relative flex-1" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center py-16 bg-white border border-gray-200 rounded-xl"
}
const _hoisted_6 = {
  key: 1,
  class: "bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm"
}
const _hoisted_7 = { class: "w-full text-sm" }
const _hoisted_8 = { class: "px-5 py-4" }
const _hoisted_9 = { class: "font-mono text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded" }
const _hoisted_10 = { class: "px-5 py-4" }
const _hoisted_11 = { class: "font-medium text-[#22282F]" }
const _hoisted_12 = {
  key: 0,
  class: "inline-flex items-center gap-1 mt-1 text-[11px] text-violet-700 bg-violet-50 border border-violet-100 px-1.5 py-0.5 rounded"
}
const _hoisted_13 = { class: "px-5 py-4" }
const _hoisted_14 = {
  key: 0,
  class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100"
}
const _hoisted_15 = {
  key: 1,
  class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-purple-50 text-purple-700 border border-purple-100"
}
const _hoisted_16 = {
  key: 2,
  class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600"
}
const _hoisted_17 = { class: "px-5 py-4" }
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "text-xs text-gray-400"
}
const _hoisted_21 = {
  key: 2,
  class: "text-xs bg-amber-50 text-amber-700 border border-amber-100 px-1.5 py-0.5 rounded"
}
const _hoisted_22 = { class: "px-5 py-4" }
const _hoisted_23 = { class: "px-5 py-4" }
const _hoisted_24 = { class: "flex items-center justify-end gap-1" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick", "title"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 2,
  class: "bg-white border border-gray-200 rounded-xl p-16 text-center shadow-sm"
}
const _hoisted_30 = { class: "text-sm text-gray-500" }
const _hoisted_31 = { class: "bg-white rounded-xl w-full max-w-lg shadow-xl max-h-[90vh] overflow-y-auto" }
const _hoisted_32 = { class: "flex items-center justify-between p-6 border-b border-gray-100" }
const _hoisted_33 = { class: "text-lg font-bold text-[#22282F]" }
const _hoisted_34 = { class: "p-6 space-y-5" }
const _hoisted_35 = { class: "flex gap-3 mb-3" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 0,
  class: "mb-2 flex items-center gap-2 text-sm text-gray-600 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2"
}
const _hoisted_40 = {
  key: 0,
  class: "mb-2 flex items-center gap-2 text-sm text-gray-600 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2"
}
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_43 = { class: "flex gap-6" }
const _hoisted_44 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_45 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_46 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_47 = { class: "flex gap-3 px-6 pb-6" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"
}
const _hoisted_50 = {
  class: "bg-white rounded-xl w-full max-w-5xl shadow-2xl overflow-hidden flex flex-col",
  style: {"max-height":"90vh"}
}
const _hoisted_51 = { class: "flex items-center justify-between px-6 py-4 border-b border-gray-100" }
const _hoisted_52 = { class: "flex items-center gap-3" }
const _hoisted_53 = { class: "font-semibold text-[#22282F]" }
const _hoisted_54 = { class: "flex flex-1 overflow-hidden" }
const _hoisted_55 = { class: "flex-1 bg-gray-100 border-r border-gray-200 flex items-center justify-center overflow-hidden" }
const _hoisted_56 = {
  key: 0,
  class: "w-full h-full flex flex-col items-center justify-center gap-4 p-8 text-center"
}
const _hoisted_57 = ["href"]
const _hoisted_58 = ["href"]
const _hoisted_59 = {
  key: 1,
  class: "flex flex-col items-center gap-3 text-gray-400"
}
const _hoisted_60 = { class: "w-72 shrink-0 overflow-y-auto p-6 space-y-5" }
const _hoisted_61 = { class: "space-y-2" }
const _hoisted_62 = { class: "text-sm font-mono font-medium text-[#22282F]" }
const _hoisted_63 = { class: "text-sm font-medium text-[#22282F]" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "text-sm text-gray-700" }
const _hoisted_66 = {
  key: 0,
  class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100"
}
const _hoisted_67 = {
  key: 1,
  class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-purple-50 text-purple-700 border border-purple-100"
}
const _hoisted_68 = {
  key: 2,
  class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600"
}
const _hoisted_69 = { class: "space-y-2" }
const _hoisted_70 = { class: "flex items-center justify-between" }
const _hoisted_71 = { class: "flex items-center justify-between" }
const _hoisted_72 = { class: "flex items-center justify-between" }
const _hoisted_73 = { class: "flex items-center justify-between" }
const _hoisted_74 = { class: "flex items-center justify-between" }
const _hoisted_75 = { class: "flex items-center justify-between" }
const _hoisted_76 = { class: "flex items-center justify-between" }
const _hoisted_77 = { class: "space-y-1.5" }
const _hoisted_78 = { class: "text-xs text-gray-700" }
const _hoisted_79 = { class: "text-xs text-gray-700" }
const _hoisted_80 = { class: "pt-2 flex flex-col gap-2" }
const _hoisted_81 = { class: "bg-white rounded-xl max-w-sm w-full p-6 shadow-xl" }
const _hoisted_82 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_83 = { class: "text-lg font-bold text-[#22282F]" }
const _hoisted_84 = { class: "text-sm text-gray-600 mb-6" }
const _hoisted_85 = { class: "flex gap-3" }

import { ref, computed, onMounted, reactive } from 'vue'
import {
  Plus, Search, FileText, Edit3, Trash2, Eye, X, Building2, Globe, Globe2,
  ToggleLeft, ToggleRight, AlertTriangle, Download, Workflow
} from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import DocumentTypeWorkflowRulesEditor from '@/components/DocumentTypeWorkflowRulesEditor.vue'
import type { RegleBrouillon } from '@/types/workflowTemplate'
import { apiFetch, API_BASE_URL } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'

interface EntityRef { id: number; nom: string; code: string }

interface WorkflowRule {
  id: number
  ordre: number
  roles: EntityRef[]
  direction: EntityRef | null
  workflow_template: { id: number; nom: string; is_active: boolean }
}

interface DocumentType {
  id: number
  code: string
  nom: string
  description: string
  is_active: boolean
  requires_ai_generation: boolean
  requires_reference: boolean
  has_template: boolean
  template_url: string | null
  has_ai_template: boolean
  ai_template_url: string | null
  direction: EntityRef | null
  ambassade: EntityRef | null
  workflow_template: { id: number; nom: string } | null
  workflow_rules: WorkflowRule[]
  created_at: string
  updated_at: string
}

interface WorkflowTemplateOption { id: number; nom: string; is_active: boolean }
interface RoleOption { id: number; code: string; nom: string }

interface Direction { id: number; code: string; nom: string }
interface Ambassade { id: number; code: string; nom: string; pays?: string }

// ─── State ────────────────────────────────────────────────────────────────────


export default /*@__PURE__*/_defineComponent({
  __name: 'TypesDocumentView',
  setup(__props) {

const toast = useToast()

// ─── Types ────────────────────────────────────────────────────────────────────

const loading = ref(false)
const saving = ref(false)

const items = ref<DocumentType[]>([])
const directions = ref<Direction[]>([])
const ambassades = ref<Ambassade[]>([])
const workflowTemplates = ref<WorkflowTemplateOption[]>([])
const roles = ref<RoleOption[]>([])

const searchQuery = ref('')
const filterScope = ref<'all' | 'global' | 'restricted'>('all')
const filterStatus = ref<'all' | 'active' | 'inactive'>('all')

const showFormModal = ref(false)
const editingItem = ref<DocumentType | null>(null)
const previewItem = ref<DocumentType | null>(null)

const scopeOptions = [
  { value: 'global', label: 'Global' },
  { value: 'direction', label: 'Direction' },
  { value: 'ambassade', label: 'Ambassade' },
]

const emptyForm = () => ({
  code: '',
  nom: '',
  description: '',
  is_active: true,
  requires_ai_generation: false,
  requires_reference: true,
  scopeType: 'global' as 'global' | 'direction' | 'ambassade',
  direction_id: '',
  ambassade_id: '',
  templateFile: null as File | null,
  aiTemplateFile: null as File | null,
  removeTemplate: false,
  removeAiTemplate: false,
  workflow_template_id: '',
  workflow_rules: [] as RegleBrouillon[],
})

const form = ref(emptyForm())

const confirmModal = reactive({
  show: false,
  type: 'delete' as 'delete' | 'toggle',
  title: '',
  message: '',
  confirmLabel: '',
  onConfirm: () => {},
})

// ─── Computed ─────────────────────────────────────────────────────────────────

const filtered = computed(() => {
  let list = items.value

  if (searchQuery.value) {
    const q = searchQuery.value.toLowerCase()
    list = list.filter(dt => dt.nom.toLowerCase().includes(q) || dt.code.toLowerCase().includes(q))
  }

  if (filterScope.value === 'global') {
    list = list.filter(dt => !dt.direction && !dt.ambassade)
  } else if (filterScope.value === 'restricted') {
    list = list.filter(dt => dt.direction || dt.ambassade)
  }

  if (filterStatus.value === 'active') {
    list = list.filter(dt => dt.is_active)
  } else if (filterStatus.value === 'inactive') {
    list = list.filter(dt => !dt.is_active)
  }

  return list
})

// ─── Fetch ────────────────────────────────────────────────────────────────────

const fetchAll = async () => {
  loading.value = true
  try {
    const [dts, dirs, ambs, wts, rls] = await Promise.all([
      apiFetch<DocumentType[]>('/api/admin/document-types/'),
      apiFetch<Direction[]>('/api/admin/directions/'),
      apiFetch<Ambassade[]>('/api/admin/ambassades/'),
      apiFetch<WorkflowTemplateOption[]>('/api/admin/workflow-templates/'),
      apiFetch<RoleOption[]>('/api/admin/roles/'),
    ])
    items.value = dts
    directions.value = dirs
    ambassades.value = ambs
    workflowTemplates.value = wts
    roles.value = rls
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Impossible de charger les données')
  } finally {
    loading.value = false
  }
}

// ─── Modals ───────────────────────────────────────────────────────────────────

const openCreateModal = () => {
  editingItem.value = null
  form.value = emptyForm()
  showFormModal.value = true
}

const openEditModal = (dt: DocumentType) => {
  editingItem.value = dt
  form.value = {
    code: dt.code,
    nom: dt.nom,
    description: dt.description,
    is_active: dt.is_active,
    requires_ai_generation: dt.requires_ai_generation,
    requires_reference: dt.requires_reference,
    scopeType: dt.direction ? 'direction' : dt.ambassade ? 'ambassade' : 'global',
    direction_id: dt.direction ? String(dt.direction.id) : '',
    ambassade_id: dt.ambassade ? String(dt.ambassade.id) : '',
    templateFile: null,
    aiTemplateFile: null,
    removeTemplate: false,
    removeAiTemplate: false,
    workflow_template_id: dt.workflow_template ? String(dt.workflow_template.id) : '',
    workflow_rules: (dt.workflow_rules ?? []).map(r => ({
      role_ids: r.roles.map(role => role.id),
      direction_id: r.direction ? String(r.direction.id) : '',
      workflow_template_id: String(r.workflow_template.id),
    })),
  }
  showFormModal.value = true
}

const closeFormModal = () => {
  showFormModal.value = false
  editingItem.value = null
}

const openPreview = (dt: DocumentType) => {
  previewItem.value = dt
}

// ─── File handlers ────────────────────────────────────────────────────────────

const onTemplateChange = (e: Event) => {
  const file = (e.target as HTMLInputElement).files?.[0] ?? null
  form.value.templateFile = file
}

const onAiTemplateChange = (e: Event) => {
  const file = (e.target as HTMLInputElement).files?.[0] ?? null
  form.value.aiTemplateFile = file
}

// ─── Save ─────────────────────────────────────────────────────────────────────

const saveForm = async () => {
  if (!form.value.code.trim() || !form.value.nom.trim()) {
    toast.error('Validation', 'Le code et le nom sont obligatoires')
    return
  }
  if (form.value.scopeType === 'direction' && !form.value.direction_id) {
    toast.error('Validation', 'Veuillez sélectionner une direction')
    return
  }
  if (form.value.scopeType === 'ambassade' && !form.value.ambassade_id) {
    toast.error('Validation', 'Veuillez sélectionner une ambassade')
    return
  }
  const regleIncomplete = form.value.workflow_rules.findIndex(r => !r.role_ids.length || !r.workflow_template_id)
  if (regleIncomplete !== -1) {
    toast.error('Validation', `Règle ${regleIncomplete + 1} : choisissez au moins un rôle et un workflow`)
    return
  }

  saving.value = true
  try {
    const fd = new FormData()
    fd.append('code', form.value.code.trim().toUpperCase())
    fd.append('nom', form.value.nom.trim())
    fd.append('description', form.value.description.trim())
    fd.append('is_active', String(form.value.is_active))
    fd.append('requires_ai_generation', String(form.value.requires_ai_generation))
    fd.append('requires_reference', String(form.value.requires_reference))

    if (form.value.scopeType === 'direction') {
      fd.append('direction_id', form.value.direction_id)
    } else if (form.value.scopeType === 'ambassade') {
      fd.append('ambassade_id', form.value.ambassade_id)
    } else {
      fd.append('direction_id', '')
      fd.append('ambassade_id', '')
    }

    fd.append('workflow_template_id', form.value.workflow_template_id)
    fd.append('workflow_rules', JSON.stringify(form.value.workflow_rules.map(r => ({
      role_ids: r.role_ids,
      direction_id: r.direction_id ? Number(r.direction_id) : null,
      workflow_template_id: Number(r.workflow_template_id),
    }))))

    if (form.value.templateFile) fd.append('template_docx', form.value.templateFile)
    if (form.value.aiTemplateFile) fd.append('ai_template_docx', form.value.aiTemplateFile)
    if (form.value.removeTemplate) fd.append('remove_template', 'true')
    if (form.value.removeAiTemplate) fd.append('remove_ai_template', 'true')

    const url = editingItem.value
      ? `/api/admin/document-types/${editingItem.value.id}/`
      : '/api/admin/document-types/'

    const saved = await apiFetch<DocumentType>(url, {
      method: editingItem.value ? 'PUT' : 'POST',
      body: fd,
      headers: {},
    })

    if (editingItem.value) {
      const idx = items.value.findIndex(d => d.id === saved.id)
      if (idx !== -1) items.value[idx] = saved
    } else {
      items.value.push(saved)
    }

    toast.success(editingItem.value ? 'Type modifié' : 'Type créé', 'L\'opération a réussi')
    closeFormModal()
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Impossible de sauvegarder')
  } finally {
    saving.value = false
  }
}

// ─── Toggle active ────────────────────────────────────────────────────────────

const askToggleActive = (dt: DocumentType) => {
  confirmModal.type = 'toggle'
  confirmModal.title = dt.is_active ? 'Désactiver ce type ?' : 'Activer ce type ?'
  confirmModal.message = dt.is_active
    ? `Le type « ${dt.nom} » sera masqué des utilisateurs. Vous pourrez le réactiver à tout moment.`
    : `Le type « ${dt.nom} » redeviendra visible pour les utilisateurs concernés.`
  confirmModal.confirmLabel = dt.is_active ? 'Désactiver' : 'Activer'
  confirmModal.onConfirm = () => doToggleActive(dt)
  confirmModal.show = true
}

const doToggleActive = async (dt: DocumentType) => {
  try {
    const result = await apiFetch<{ id: number; is_active: boolean }>(
      `/api/admin/document-types/${dt.id}/toggle-active/`,
      { method: 'PATCH' }
    )
    const idx = items.value.findIndex(d => d.id === dt.id)
    if (idx !== -1) items.value[idx] = { ...items.value[idx], is_active: result.is_active }
    toast.success(
      result.is_active ? 'Type activé' : 'Type désactivé',
      `« ${dt.nom} » a été mis à jour`
    )
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Impossible de modifier le statut')
  }
}

// ─── Delete ───────────────────────────────────────────────────────────────────

const askDelete = (dt: DocumentType) => {
  confirmModal.type = 'delete'
  confirmModal.title = 'Supprimer ce type ?'
  confirmModal.message = `La suppression du type « ${dt.nom} » (${dt.code}) est irréversible. Les documents existants utilisant ce type ne seront pas affectés, mais il ne sera plus proposé à la création.`
  confirmModal.confirmLabel = 'Supprimer'
  confirmModal.onConfirm = () => doDelete(dt)
  confirmModal.show = true
}

const doDelete = async (dt: DocumentType) => {
  try {
    await apiFetch(`/api/admin/document-types/${dt.id}/`, { method: 'DELETE' })
    items.value = items.value.filter(d => d.id !== dt.id)
    toast.success('Type supprimé', `« ${dt.nom} » a été supprimé`)
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Impossible de supprimer ce type')
  }
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

const libelleRegles = (n: number) => `${n} règle${n > 1 ? 's' : ''}`

const formatDate = (iso: string) => {
  return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

onMounted(fetchAll)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[22] || (_cache[22] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-2xl font-bold text-[#22282F]" }, "Types de document"),
            _createElementVNode("p", { class: "text-sm text-gray-500 mt-1" }, "Gérez les modèles de documents et leurs restrictions d'accès")
          ], -1)),
          _createElementVNode("button", {
            onClick: openCreateModal,
            class: "px-4 py-2 bg-[#22282F] text-white rounded-lg hover:bg-[#22282F]/90 transition-colors flex items-center gap-2"
          }, [
            _createVNode(_unref(Plus), { class: "w-4 h-4" }),
            _cache[21] || (_cache[21] = _createTextVNode(" Nouveau type "))
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Search), { class: "absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              type: "text",
              placeholder: "Rechercher par nom ou code...",
              class: "w-full pl-12 pr-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20"
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ])
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterScope).value = $event)),
            class: "px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] bg-white"
          }, _cache[23] || (_cache[23] = [
            _createElementVNode("option", { value: "all" }, "Tous les types", -1),
            _createElementVNode("option", { value: "global" }, "Globaux uniquement", -1),
            _createElementVNode("option", { value: "restricted" }, "Restreints uniquement", -1)
          ]), 512), [
            [_vModelSelect, filterScope.value]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterStatus).value = $event)),
            class: "px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] bg-white"
          }, _cache[24] || (_cache[24] = [
            _createElementVNode("option", { value: "all" }, "Tous statuts", -1),
            _createElementVNode("option", { value: "active" }, "Actifs", -1),
            _createElementVNode("option", { value: "inactive" }, "Inactifs", -1)
          ]), 512), [
            [_vModelSelect, filterStatus.value]
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[25] || (_cache[25] = [
              _createElementVNode("div", { class: "w-8 h-8 border-4 border-gray-200 border-t-[#22282F] rounded-full animate-spin" }, null, -1)
            ])))
          : (filtered.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", { class: "border-b border-gray-100 bg-gray-50" }, [
                      _createElementVNode("th", { class: "text-left px-5 py-3 font-semibold text-gray-600" }, "Code"),
                      _createElementVNode("th", { class: "text-left px-5 py-3 font-semibold text-gray-600" }, "Nom"),
                      _createElementVNode("th", { class: "text-left px-5 py-3 font-semibold text-gray-600" }, "Entité"),
                      _createElementVNode("th", { class: "text-left px-5 py-3 font-semibold text-gray-600" }, "Template"),
                      _createElementVNode("th", { class: "text-left px-5 py-3 font-semibold text-gray-600" }, "Statut"),
                      _createElementVNode("th", { class: "text-right px-5 py-3 font-semibold text-gray-600" }, "Actions")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (dt) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: dt.id,
                        class: "border-b border-gray-50 hover:bg-gray-50/70 transition-colors group"
                      }, [
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(dt.code), 1)
                        ]),
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(dt.nom), 1),
                          (dt.workflow_template || dt.workflow_rules?.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                _createVNode(_unref(Workflow), { class: "w-3 h-3" }),
                                _createTextVNode(" " + _toDisplayString(dt.workflow_template?.nom || 'Aucun workflow par défaut') + " ", 1),
                                (dt.workflow_rules?.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("+ " + _toDisplayString(libelleRegles(dt.workflow_rules.length)), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          (dt.direction)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _createVNode(_unref(Building2), { class: "w-3 h-3" }),
                                _createTextVNode(" " + _toDisplayString(dt.direction.code), 1)
                              ]))
                            : (dt.ambassade)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                  _createVNode(_unref(Globe), { class: "w-3 h-3" }),
                                  _createTextVNode(" " + _toDisplayString(dt.ambassade.code), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                  _createVNode(_unref(Globe2), { class: "w-3 h-3" }),
                                  _cache[26] || (_cache[26] = _createTextVNode(" Global "))
                                ]))
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            (dt.has_template)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (openPreview(dt)),
                                  class: "inline-flex items-center gap-1 text-xs text-[#22282F] hover:underline",
                                  title: "Prévisualiser"
                                }, [
                                  _createVNode(_unref(FileText), { class: "w-3.5 h-3.5" }),
                                  _cache[27] || (_cache[27] = _createTextVNode(" Voir "))
                                ], 8, _hoisted_19))
                              : (_openBlock(), _createElementBlock("span", _hoisted_20, "Aucun")),
                            (dt.has_ai_template)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "IA"))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("span", {
                            class: _normalizeClass([
                    'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
                    dt.is_active
                      ? 'bg-green-50 text-green-700 border border-green-100'
                      : 'bg-red-50 text-red-700 border border-red-100'
                  ])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(['w-1.5 h-1.5 rounded-full', dt.is_active ? 'bg-green-500' : 'bg-red-400'])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(dt.is_active ? 'Actif' : 'Inactif'), 1)
                          ], 2)
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (openPreview(dt)),
                              class: "p-2 hover:bg-gray-100 rounded-lg transition-colors",
                              title: "Prévisualiser"
                            }, [
                              _createVNode(_unref(Eye), { class: "w-4 h-4 text-gray-500" })
                            ], 8, _hoisted_25),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (openEditModal(dt)),
                              class: "p-2 hover:bg-gray-100 rounded-lg transition-colors",
                              title: "Modifier"
                            }, [
                              _createVNode(_unref(Edit3), { class: "w-4 h-4 text-gray-500" })
                            ], 8, _hoisted_26),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (askToggleActive(dt)),
                              class: "p-2 hover:bg-gray-100 rounded-lg transition-colors",
                              title: dt.is_active ? 'Désactiver' : 'Activer'
                            }, [
                              (dt.is_active)
                                ? (_openBlock(), _createBlock(_unref(ToggleLeft), {
                                    key: 0,
                                    class: "w-4 h-4 text-green-600"
                                  }))
                                : (_openBlock(), _createBlock(_unref(ToggleRight), {
                                    key: 1,
                                    class: "w-4 h-4 text-gray-400"
                                  }))
                            ], 8, _hoisted_27),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (askDelete(dt)),
                              class: "p-2 hover:bg-red-50 rounded-lg transition-colors",
                              title: "Supprimer"
                            }, [
                              _createVNode(_unref(Trash2), { class: "w-4 h-4 text-red-500" })
                            ], 8, _hoisted_28)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_unref(FileText), { class: "w-14 h-14 text-gray-200 mx-auto mb-4" }),
                _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "text-lg font-semibold text-[#22282F] mb-1" }, "Aucun type de document", -1)),
                _createElementVNode("p", _hoisted_30, _toDisplayString(searchQuery.value || filterScope.value !== 'all' || filterStatus.value !== 'all' ? 'Aucun résultat pour ces filtres' : 'Créez votre premier type de document'), 1)
              ]))
      ]),
      (showFormModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50",
            onClick: _withModifiers(closeFormModal, ["self"])
          }, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("h3", _hoisted_33, _toDisplayString(editingItem.value ? 'Modifier le type de document' : 'Nouveau type de document'), 1),
                _createElementVNode("button", {
                  onClick: closeFormModal,
                  class: "p-2 hover:bg-gray-100 rounded-lg"
                }, [
                  _createVNode(_unref(X), { class: "w-5 h-5 text-gray-500" })
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", null, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-sm font-medium text-[#22282F] mb-1.5" }, [
                    _createTextVNode("Code "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.code) = $event)),
                    type: "text",
                    placeholder: "ex: NOTE_VERBALE",
                    class: "w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20 font-mono"
                  }, null, 512), [
                    [_vModelText, form.value.code]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block text-sm font-medium text-[#22282F] mb-1.5" }, [
                    _createTextVNode("Nom "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.nom) = $event)),
                    type: "text",
                    placeholder: "ex: Note Verbale",
                    class: "w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20"
                  }, null, 512), [
                    [_vModelText, form.value.nom]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-sm font-medium text-[#22282F] mb-1.5" }, "Description", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.description) = $event)),
                    rows: "2",
                    placeholder: "Description optionnelle...",
                    class: "w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20 resize-none"
                  }, null, 512), [
                    [_vModelText, form.value.description]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block text-sm font-medium text-[#22282F] mb-2" }, "Restriction d'accès", -1)),
                  _createElementVNode("div", _hoisted_35, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scopeOptions, (opt) => {
                      return _createElementVNode("button", {
                        key: opt.value,
                        onClick: ($event: any) => (form.value.scopeType = opt.value),
                        class: _normalizeClass([
                  'flex-1 py-2 px-3 rounded-lg border text-sm font-medium transition-colors',
                  form.value.scopeType === opt.value
                    ? 'bg-[#22282F] text-white border-[#22282F]'
                    : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300'
                ])
                      }, _toDisplayString(opt.label), 11, _hoisted_36)
                    }), 64))
                  ]),
                  (form.value.scopeType === 'direction')
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.direction_id) = $event)),
                        class: "w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] bg-white"
                      }, [
                        _cache[33] || (_cache[33] = _createElementVNode("option", { value: "" }, "-- Choisir une direction --", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directions.value, (d) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: d.id,
                            value: String(d.id)
                          }, _toDisplayString(d.code) + " — " + _toDisplayString(d.nom), 9, _hoisted_37))
                        }), 128))
                      ], 512)), [
                        [_vModelSelect, form.value.direction_id]
                      ])
                    : _createCommentVNode("", true),
                  (form.value.scopeType === 'ambassade')
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 1,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.ambassade_id) = $event)),
                        class: "w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] bg-white"
                      }, [
                        _cache[34] || (_cache[34] = _createElementVNode("option", { value: "" }, "-- Choisir une ambassade --", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ambassades.value, (a) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: a.id,
                            value: String(a.id)
                          }, _toDisplayString(a.code) + " — " + _toDisplayString(a.nom), 9, _hoisted_38))
                        }), 128))
                      ], 512)), [
                        [_vModelSelect, form.value.ambassade_id]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block text-sm font-medium text-[#22282F] mb-1.5" }, "Template DOCX", -1)),
                  (editingItem.value?.has_template && !form.value.removeTemplate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_unref(FileText), { class: "w-4 h-4 text-gray-400" }),
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "flex-1 truncate" }, "Fichier actuel", -1)),
                        _createElementVNode("button", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (form.value.removeTemplate = true)),
                          class: "text-red-500 hover:text-red-600 text-xs"
                        }, "Supprimer")
                      ]))
                    : _createCommentVNode("", true),
                  (!editingItem.value?.has_template || form.value.removeTemplate)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "file",
                        accept: ".docx",
                        onChange: onTemplateChange,
                        class: "w-full text-sm text-gray-500 file:mr-3 file:py-2 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200"
                      }, null, 32))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block text-sm font-medium text-[#22282F] mb-1.5" }, "Template IA (optionnel)", -1)),
                  (editingItem.value?.has_ai_template && !form.value.removeAiTemplate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createVNode(_unref(FileText), { class: "w-4 h-4 text-amber-400" }),
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "flex-1 truncate" }, "Template IA actuel", -1)),
                        _createElementVNode("button", {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (form.value.removeAiTemplate = true)),
                          class: "text-red-500 hover:text-red-600 text-xs"
                        }, "Supprimer")
                      ]))
                    : _createCommentVNode("", true),
                  (!editingItem.value?.has_ai_template || form.value.removeAiTemplate)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "file",
                        accept: ".docx",
                        onChange: onAiTemplateChange,
                        class: "w-full text-sm text-gray-500 file:mr-3 file:py-2 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-amber-50 file:text-amber-700 hover:file:bg-amber-100"
                      }, null, 32))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block text-sm font-medium text-[#22282F] mb-1.5" }, "Workflow de validation", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.workflow_template_id) = $event)),
                    class: "w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] bg-white"
                  }, [
                    _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "Aucun — circuit saisi manuellement à chaque rédaction", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workflowTemplates.value.filter(w => w.is_active), (wt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: wt.id,
                        value: String(wt.id)
                      }, _toDisplayString(wt.nom), 9, _hoisted_41))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, form.value.workflow_template_id]
                  ]),
                  _createElementVNode("p", _hoisted_42, [
                    _cache[42] || (_cache[42] = _createTextVNode(" Pré-remplit automatiquement le circuit de validation à la rédaction. ")),
                    _createVNode(_component_router_link, {
                      to: "/workflow-templates",
                      class: "text-[#22282F] underline"
                    }, {
                      default: _withCtx(() => _cache[41] || (_cache[41] = [
                        _createTextVNode("Gérer les workflows")
                      ])),
                      _: 1,
                      __: [41]
                    })
                  ])
                ]),
                _createVNode(DocumentTypeWorkflowRulesEditor, {
                  modelValue: form.value.workflow_rules,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.workflow_rules) = $event)),
                  roles: roles.value,
                  directions: directions.value,
                  "workflow-templates": workflowTemplates.value
                }, null, 8, ["modelValue", "roles", "directions", "workflow-templates"]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.is_active) = $event)),
                      class: "rounded"
                    }, null, 512), [
                      [_vModelCheckbox, form.value.is_active]
                    ]),
                    _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-sm text-gray-700" }, "Actif", -1))
                  ]),
                  _createElementVNode("label", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.requires_ai_generation) = $event)),
                      class: "rounded"
                    }, null, 512), [
                      [_vModelCheckbox, form.value.requires_ai_generation]
                    ]),
                    _cache[45] || (_cache[45] = _createElementVNode("span", { class: "text-sm text-gray-700" }, "Flux IA", -1))
                  ]),
                  _createElementVNode("label", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.requires_reference) = $event)),
                      class: "rounded"
                    }, null, 512), [
                      [_vModelCheckbox, form.value.requires_reference]
                    ]),
                    _cache[46] || (_cache[46] = _createElementVNode("span", { class: "text-sm text-gray-700" }, "Nécessite une référence", -1))
                  ])
                ]),
                _cache[47] || (_cache[47] = _createElementVNode("p", { class: "text-xs text-gray-400 -mt-4" }, " Décocher pour une note interne qui ne sort pas du ministère (ex: note à l'attention de la Ministre) : aucun numéro de référence officiel ne sera généré, et le template n'a pas besoin du placeholder [REFERENCE]. ", -1))
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  onClick: closeFormModal,
                  class: "flex-1 px-4 py-2.5 border border-gray-200 rounded-lg text-sm hover:bg-gray-50 transition-colors"
                }, " Annuler "),
                _createElementVNode("button", {
                  onClick: saveForm,
                  disabled: saving.value,
                  class: "flex-1 px-4 py-2.5 bg-[#22282F] text-white rounded-lg text-sm hover:bg-[#22282F]/90 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                }, [
                  (saving.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(editingItem.value ? 'Enregistrer' : 'Créer'), 1)
                ], 8, _hoisted_48)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (previewItem.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50",
            onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (previewItem.value = null), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_unref(FileText), { class: "w-5 h-5 text-gray-500" }),
                  _createElementVNode("span", _hoisted_53, "Prévisualisation — " + _toDisplayString(previewItem.value.nom), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (previewItem.value = null)),
                  class: "p-2 hover:bg-gray-100 rounded-lg"
                }, [
                  _createVNode(_unref(X), { class: "w-5 h-5 text-gray-500" })
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  (previewItem.value.has_template && previewItem.value.template_url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createVNode(_unref(FileText), { class: "w-16 h-16 text-gray-300" }),
                        _cache[50] || (_cache[50] = _createElementVNode("p", { class: "text-sm text-gray-500 max-w-xs" }, "La prévisualisation directe des fichiers DOCX n'est pas supportée dans le navigateur.", -1)),
                        _createElementVNode("a", {
                          href: previewItem.value.template_url,
                          target: "_blank",
                          download: "",
                          class: "inline-flex items-center gap-2 px-4 py-2 bg-[#22282F] text-white rounded-lg text-sm hover:bg-[#22282F]/90 transition-colors"
                        }, [
                          _createVNode(_unref(Download), { class: "w-4 h-4" }),
                          _cache[48] || (_cache[48] = _createTextVNode(" Télécharger le template "))
                        ], 8, _hoisted_57),
                        (previewItem.value.has_ai_template && previewItem.value.ai_template_url)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: previewItem.value.ai_template_url,
                              target: "_blank",
                              download: "",
                              class: "inline-flex items-center gap-2 px-4 py-2 border border-amber-300 text-amber-700 bg-amber-50 rounded-lg text-sm hover:bg-amber-100 transition-colors"
                            }, [
                              _createVNode(_unref(Download), { class: "w-4 h-4" }),
                              _cache[49] || (_cache[49] = _createTextVNode(" Télécharger le template IA "))
                            ], 8, _hoisted_58))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createVNode(_unref(FileText), { class: "w-14 h-14" }),
                        _cache[51] || (_cache[51] = _createElementVNode("p", { class: "text-sm" }, "Aucun template associé", -1))
                      ]))
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", null, [
                    _cache[55] || (_cache[55] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2" }, "Identité", -1)),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", null, [
                        _cache[52] || (_cache[52] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Code", -1)),
                        _createElementVNode("p", _hoisted_62, _toDisplayString(previewItem.value.code), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[53] || (_cache[53] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Nom", -1)),
                        _createElementVNode("p", _hoisted_63, _toDisplayString(previewItem.value.nom), 1)
                      ]),
                      (previewItem.value.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _cache[54] || (_cache[54] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Description", -1)),
                            _createElementVNode("p", _hoisted_65, _toDisplayString(previewItem.value.description), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[57] || (_cache[57] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2" }, "Accès", -1)),
                    _createElementVNode("div", null, [
                      (previewItem.value.direction)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                            _createVNode(_unref(Building2), { class: "w-3 h-3" }),
                            _createTextVNode(" Direction : " + _toDisplayString(previewItem.value.direction.nom), 1)
                          ]))
                        : (previewItem.value.ambassade)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                              _createVNode(_unref(Globe), { class: "w-3 h-3" }),
                              _createTextVNode(" Ambassade : " + _toDisplayString(previewItem.value.ambassade.nom), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_68, [
                              _createVNode(_unref(Globe2), { class: "w-3 h-3" }),
                              _cache[56] || (_cache[56] = _createTextVNode(" Tous les utilisateurs "))
                            ]))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[65] || (_cache[65] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2" }, "Configuration", -1)),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Statut", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['text-xs font-medium px-2 py-0.5 rounded-full', previewItem.value.is_active ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-600'])
                        }, _toDisplayString(previewItem.value.is_active ? 'Actif' : 'Inactif'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Flux IA", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['text-xs font-medium px-2 py-0.5 rounded-full', previewItem.value.requires_ai_generation ? 'bg-amber-50 text-amber-700' : 'bg-gray-100 text-gray-500'])
                        }, _toDisplayString(previewItem.value.requires_ai_generation ? 'Oui' : 'Non'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _cache[60] || (_cache[60] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Nécessite une référence", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['text-xs font-medium px-2 py-0.5 rounded-full', previewItem.value.requires_reference ? 'bg-amber-50 text-amber-700' : 'bg-gray-100 text-gray-500'])
                        }, _toDisplayString(previewItem.value.requires_reference ? 'Oui' : 'Non'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _cache[61] || (_cache[61] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Template standard", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['text-xs font-medium px-2 py-0.5 rounded-full', previewItem.value.has_template ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-500'])
                        }, _toDisplayString(previewItem.value.has_template ? 'Oui' : 'Non'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _cache[62] || (_cache[62] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Template IA", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['text-xs font-medium px-2 py-0.5 rounded-full', previewItem.value.has_ai_template ? 'bg-amber-50 text-amber-700' : 'bg-gray-100 text-gray-500'])
                        }, _toDisplayString(previewItem.value.has_ai_template ? 'Oui' : 'Non'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _cache[63] || (_cache[63] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Workflow prédéfini", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['text-xs font-medium px-2 py-0.5 rounded-full', previewItem.value.workflow_template ? 'bg-violet-50 text-violet-700' : 'bg-gray-100 text-gray-500'])
                        }, _toDisplayString(previewItem.value.workflow_template?.nom || 'Aucun'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _cache[64] || (_cache[64] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Circuits selon le profil", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['text-xs font-medium px-2 py-0.5 rounded-full', previewItem.value.workflow_rules?.length ? 'bg-violet-50 text-violet-700' : 'bg-gray-100 text-gray-500'])
                        }, _toDisplayString(previewItem.value.workflow_rules?.length ? libelleRegles(previewItem.value.workflow_rules.length) : 'Aucun'), 3)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[68] || (_cache[68] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2" }, "Dates", -1)),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", null, [
                        _cache[66] || (_cache[66] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Créé le", -1)),
                        _createElementVNode("p", _hoisted_78, _toDisplayString(formatDate(previewItem.value.created_at)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[67] || (_cache[67] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Modifié le", -1)),
                        _createElementVNode("p", _hoisted_79, _toDisplayString(formatDate(previewItem.value.updated_at)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("button", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => {openEditModal(previewItem.value); previewItem.value = null}),
                      class: "w-full px-3 py-2 bg-[#22282F] text-white rounded-lg text-sm hover:bg-[#22282F]/90 transition-colors flex items-center justify-center gap-2"
                    }, [
                      _createVNode(_unref(Edit3), { class: "w-4 h-4" }),
                      _cache[69] || (_cache[69] = _createTextVNode(" Modifier "))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (confirmModal.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50",
            onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (confirmModal.show = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", {
                  class: _normalizeClass(['p-2.5 rounded-full', confirmModal.type === 'delete' ? 'bg-red-100' : 'bg-amber-100'])
                }, [
                  _createVNode(_unref(AlertTriangle), {
                    class: _normalizeClass(['w-5 h-5', confirmModal.type === 'delete' ? 'text-red-600' : 'text-amber-600'])
                  }, null, 8, ["class"])
                ], 2),
                _createElementVNode("h3", _hoisted_83, _toDisplayString(confirmModal.title), 1)
              ]),
              _createElementVNode("p", _hoisted_84, _toDisplayString(confirmModal.message), 1),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("button", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (confirmModal.show = false)),
                  class: "flex-1 px-4 py-2.5 border border-gray-200 rounded-lg text-sm hover:bg-gray-50 transition-colors"
                }, " Annuler "),
                _createElementVNode("button", {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => {confirmModal.onConfirm(); confirmModal.show = false}),
                  class: _normalizeClass([
              'flex-1 px-4 py-2.5 rounded-lg text-sm text-white transition-colors',
              confirmModal.type === 'delete' ? 'bg-red-600 hover:bg-red-700' : 'bg-amber-500 hover:bg-amber-600'
            ])
                }, _toDisplayString(confirmModal.confirmLabel), 3)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})